import { render, staticRenderFns } from "./archiveDetail.vue?vue&type=template&id=5296ab43&scoped=true"
import script from "./archiveDetail.vue?vue&type=script&lang=js"
export * from "./archiveDetail.vue?vue&type=script&lang=js"
import style0 from "./archiveDetail.vue?vue&type=style&index=0&id=5296ab43&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5296ab43",
  null
  
)

export default component.exports